var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.head_changes
        ? _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("span", { staticClass: "font-weight-black" }, [
                  _vm._v(" Metadata changes: "),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.headerChanges.changes, function (change) {
        return _c("ChangeItem", { key: change.name, attrs: { change: change } })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }